import EventDispatcher from '../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher';

export default class PuzzleModel extends EventDispatcher {


    constructor(location, target, items) {
        super();
        this._location = location;
        this._target = target;
        this._items = items;
        this._dragDistance = 0;
        this.reset();
    }

    /**@type {Number} Index of target item.*/
    get target() {
        return this._target;
    }

    /**@type {Number} Index of location.*/
    get location() {
        return this._location;
    }

    /**@type {Array<Number>} Array of item indexes.*/
    get slots() {
        return this._slots;
    }

    set position(value) {
        this._position = value;
    }
    /**
     * @type {{x:Number,y:Number}} 
     */
    get position() {
        return this._position;
    }

    set dragDistance(value) {
        this._dragDistance = value;
    }
    /**
     * @type {Number} 
     */
    get dragDistance() {
        return this._dragDistance;
    }

    reset() {
        this._slots = this._items.slice(0);
    }

    /**
     * 
     * @param {Number} index - Index of slot to set
     * @param {Number} value - index of item
     */
    setSlot(index, value) {
        this._slots[index] = value;
    }

    getSlot(index) {
        return this._slots[index];
    }

    _applyState(state) {
        state.emptySlots.forEach(slotIndex => {
            this._slots[slotIndex] = null;
        });
        this.position = state.position;
        this.dragDistance = state.dragDistance;
    }

    getState() {
        const emptySlotIndices = [];
        this._slots.forEach((itemIndex, idx) => {
            if (itemIndex == null) {
                emptySlotIndices.push(idx);
            }
        })
        return { emptySlots: emptySlotIndices, position: this.position, dragDistance: Math.round(this.dragDistance) };
    }


    /*****************************
     *      SAVEGAME RELATED
     *****************************/

    toObject() {
        const state = this.getState();
        return {
            state: state
        }
    }

    /**
     * 
     * @param {Object} object - see keys in PuzzleModel.toObject()
     */
    setFromObject(object) {
        const state = object.state;
        if (state) {
            this._applyState(state);
        }
    }
}